import { EndOfDate, FormattedDateString, StartOfDate } from '@red/data-access';
import { Expose } from 'class-transformer';
import { ListFiltersBase } from './list-filters.base';


export class AuditTrailFilters extends ListFiltersBase {
  @Expose()
  companyIds!: string;

  @Expose()
  module!: string;

  @Expose()
  entityName!: string[];

  @Expose()
  entityId!: string;

  @Expose()
  user!: string;

  @Expose()
  @StartOfDate()
  @FormattedDateString()
  createdAtFrom!: string;

  @Expose()
  @EndOfDate()
  @FormattedDateString()
  createdAtTo!: string;

  @Expose()
  action!: string[];

}
